import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { isSameProduct, Suggestion } from '../../_models/product-suggestion-res.model';

// Suggested products, one table per category.
@Component({
  selector: 'app-product-table',
  imports: [TranslatePipe, MatCheckboxModule, MatTableModule],
  templateUrl: './product-table.html',
  styleUrl: './product-table.scss',
})
export class ProductTable {
  @Input() suggestions: Suggestion[] = [];
  @Input() selectedProducts: Suggestion[] = [];

  @Output() selectedProductsChange = new EventEmitter<Suggestion[]>();

  public readonly columns = ['select', 'product', 'organisation'];

  // Category 1 first.
  get categories(): number[] {
    return [...new Set(this.suggestions.map((s) => s.category))].sort((a, b) => a - b);
  }

  public forCategory(category: number): Suggestion[] {
    return this.suggestions.filter((s) => s.category === category);
  }

  public isSelected(suggestion: Suggestion): boolean {
    return this.selectedProducts.some((p) => isSameProduct(p, suggestion));
  }

  public updateSelection(checked: boolean, suggestion: Suggestion): void {
    if (checked && this.isSelected(suggestion)) {
      return;
    }

    this.selectedProducts = checked
      ? [...this.selectedProducts, suggestion]
      : this.selectedProducts.filter((p) => !isSameProduct(p, suggestion));
    this.selectedProductsChange.emit(this.selectedProducts);
  }
}
